import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { PhotoViewerComponent } from 'src/app/photo-viewer/photo-viewer.component';
import { PatientService } from 'src/app/services/patient.service';
import { ToolService } from 'src/app/services/tool.service';

@Component({
  selector: 'app-graphy',
  templateUrl: './graphy.component.html',
  styleUrls: ['./graphy.component.scss'],
})
export class GraphyComponent implements OnInit {

  public data = [];

  constructor(private service : PatientService, private storage : Storage, private tool : ToolService, private modalController: ModalController) { }

  ngOnInit() {
    this.storage.get('graphy_files').then(val =>{
      if(val)
        this.data = val;
      else{
        this.service.GetGraphies().toPromise()
        .catch(err =>{
          if(err){
            return;
          }
        })
        .then(res =>{
          if(res){
            res.data.forEach(element => {
              element.Date = this.tool.ConvertToPersianDateTime(element.Date);
              this.data.push(element);
            });
            this.storage.set('graphy_files', this.data)
          }
        })
      }
    })
  }

  Refresh(ev){
    this.service.GetGraphies().toPromise()
    .catch(err =>{
      if(err){
        ev.target.complete();
        return;
      }
    })
    .then(res =>{
      if(res){
        this.data = [];
        res.data.forEach(element => {
          element.Date = this.tool.ConvertToPersianDateTime(element.Date);
          this.data.push(element);
        });
        this.storage.set('graphy_files', this.data).then(() => ev.target.complete());
      }
    })
  }

  ShowImage(data) {
    this.modalController.create({
      component: PhotoViewerComponent,
      componentProps: {
        'Data': data,
      }
    }).then(m => m.present());
  }

}
